import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { api, errorText } from "@/lib/api";
import { Field } from "@/components/onboarding/Field";
import { BrandMark } from "@/components/onboarding/BrandMark";

export const BrandSettings = ({ brand, onSaved }) => {
  const [form, setForm] = useState(brand);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.put("/msp/brand", form); toast.success("Branding saved"); onSaved(); } catch (err) { toast.error(errorText(err)); }
    setBusy(false);
  };

  return (
    <form onSubmit={save} className="rounded-lg border border-[#222D3D] bg-[#0F141C] p-6 grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_280px] gap-8" data-testid="brand-settings-form">
      <div className="space-y-4 min-w-0">
        <h2 className="text-lg font-semibold text-slate-100">Branding</h2>
        <Field id="brand-name" label="Name shown to properties" required value={form.name} onChange={set("name")} />
        <Field id="brand-logo" label="Logo image link (optional)" placeholder="https://…" value={form.logo_url} onChange={set("logo_url")} hint="A secure (https) link to your logo. Leave empty to show your initial." />
        <div className="space-y-2">
          <Label htmlFor="brand-color">Main colour</Label>
          <div className="flex items-center gap-3">
            <input id="brand-color" type="color" value={form.color} onChange={set("color")} className="h-9 w-12 rounded border border-[#222D3D] bg-transparent" data-testid="brand-color-input" />
            <span className="font-mono text-xs text-slate-400">{form.color}</span>
          </div>
        </div>
        <Button type="submit" disabled={busy} className="bg-emerald-500 hover:bg-emerald-400 text-[#07090E] font-semibold" data-testid="brand-save-btn">Save branding</Button>
      </div>
      <div className="rounded-md border border-[#222D3D] bg-[#07090E] p-5 space-y-4 min-w-0" data-testid="brand-preview">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">Preview</p>
        <BrandMark brand={{ ...form, name: form.name || "Your company" }} />
        <div className="h-9 rounded-md grid place-items-center text-sm font-semibold text-white" style={{ background: form.color }}>Continue to payment</div>
      </div>
    </form>
  );
};
